import React from 'react'

function Status({ status = "placed" }) {

    let bg = "bg-[#e38a5b]"

    const status1 = status.toLowerCase()

    if (status1 === "delivered" || status1 === "in stock") {
        bg = "bg-[#4dd1b0]"
    } else if (status1 === "cancelled" || status1 === "out of stock") {
        bg = "bg-[#e33636]"
    } else if (status1 === "placed") {
        bg = "bg-[#e38a5b]"
    } else if (status1 === "processing" || status === "en_route") {
        bg = "bg-[#f7f023]"
    }

    return (
        <div className='flex items-center gap-2 text-sm'>
            <div className={`size-[9px] rounded-full ${bg}`} />
            {status}
        </div >
    )
}

export default Status